<div class="host-operate-bar flex flex-row items-center justify-between" [formGroup]="form">
  <div class="v4-filter-list">
    <!-- 月份 -->
    <div class="v4-filter-item">
      <nz-select
        formControlName="month"
        [nzPlaceHolder]="'placeholder.choose_date_required' | translate"
        [nzDropdownMatchSelectWidth]="false">
        @for (opt of listOfMonthOptions; track $index) {
          <nz-option [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        }
      </nz-select>
    </div>

    <!-- 渠道 -->
    <div class="v4-filter-item" *ngIf="type === 'price' && filters.indexOf('channel') !== -1">
      <host-simple-multi-select
        class="v4-filter-style"
        formControlName="thirdparty_type"
        placeholderKey="word.select_option.placeholder.channel"
        [listOfOption]="listOfThirdpartyOptions"></host-simple-multi-select>
    </div>

    <!-- 房型 -->
    <div class="v4-filter-item" *ngIf="filters.indexOf('room_type') !== -1">
      <v4-room-types-select class="v4-filter-style" formControlName="house_type_id"></v4-room-types-select>
    </div>

    <!-- 分组 -->
    <div class="v4-filter-item" *ngIf="filters.indexOf('group') !== -1">
      <host-select
        class="v4-filter-style"
        [placeholder]="'word.group' | translate"
        [defaultValue]="null"
        [listOfOption]="optionsOfGroup"
        formControlName="group_id"></host-select>
    </div>

    <!-- 清洁状态 -->
    <div class="v4-filter-item" *ngIf="type === 'status' && filters.indexOf('cleaning_status') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="house_cleaning_status"
        [defaultValue]="null"
        [listOfOption]="listOfCleaningOption"
        [placeholder]="'placeholder.any_clean_status' | translate"></host-select>
    </div>

    <!-- 今日房态 -->
    <div class="v4-filter-item" *ngIf="isInternational && type === 'status' && filters.indexOf('room_status') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="today_status"
        [placeholder]="'placeholder.current_house_status' | translate"
        [defaultValue]="null"
        [listOfOption]="listOfTodayInfoOptions"></host-select>
    </div>

    <!-- 子账号 -->
    <div class="v4-filter-item" *ngIf="type === 'status' && filters.indexOf('team_accounts') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="operator_relation_id"
        [defaultValue]="null"
        [placeholder]="'placeholder.subaccount_for_house_filter' | translate"
        [listOfOption]="listOfSubaccountOptions"></host-select>
    </div>

    <!-- 筛选 -->
    <div class="v4-filter-item">
      <host-filters-picker
        [listOfOption]="optionsOfFilter"
        [(ngModel)]="filters"
        (ngModelChange)="onFilterChange($event)"
        [ngModelOptions]="{ standalone: true }"></host-filters-picker>
    </div>
  </div>

  <div class="ml-[24px] item flex flex-row items-center" *ngIf="type === 'status' && !isInternational">
    <!-- <span class="mr-3 text-sm">{{ "calendar.operator.filter.word.today" | translate }}</span> -->
    <div>
      <nz-radio-group class="whitespace-nowrap" formControlName="today_status" [nzButtonStyle]="'solid'">
        <label nz-radio-button [nzValue]="info.value" *ngFor="let info of listOfTodayInfoOptions"
          >{{ info.label }} {{ info.total }}</label
        >
      </nz-radio-group>
    </div>
  </div>

  <div class="v4-filter-list ml-[24px]">
    <div class="v4-filter-item" *ngIf="!isInternational && type === 'price'">
      <a nz-button nzType="link" nzSize="small" (click)="onClickDisplayPriceTip.emit()">
        <!-- 价格说明 -->
        {{ "calendar.price_info.tip" | translate }}
      </a>
    </div>
    <!-- <div class="v4-filter-item" *ngIf="type === 'price'">
      <button class="no-min-width" nz-button nz-dropdown nzTrigger="click" [nzDropdownMenu]="viewMenu">
        <span>{{ 'guest.list.btn.view' | translate }}</span>
      </button>

      <nz-dropdown-menu #viewMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="onToggleDisplayStock.emit(!displayStock)">
            <i *ngIf="!displayStock" class="text-primary mr-1" nz-icon nzType="check" nzTheme="outline"></i>
            <span>
              {{ 'calendar.filter.hide_stock' | translate }}
            </span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div> -->
    <!-- <div class="v4-filter-item">
      <button nz-button (click)="onClickSync.emit()">
        <i nz-icon nzType="sync" nzTheme="outline"></i>
        {{ (type === "status" ? "calendar.sync_order" : "calendar.sync_calendar") | translate }}
      </button>
    </div> -->
    <!-- <div class="v4-filter-item" *ngIf="type === 'price'">
      <a routerLink="/app/price/bulk-price-editing">
        <button nz-button nzType="primary">
          {{ 'price-operate_bar_html_批量改价' | translate }}
        </button>
      </a>
    </div> -->
  </div>
</div>
